import styled from 'styled-components';

import theme from '@theme/FolxTheme';

const Grid = styled.div`
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	column-gap: ${theme.spacing.sm};
	row-gap: 0;
	width: 100%;
	padding: 0 ${theme.spacing.lg};

	> div[tabindex='-1'] {
		display: contents;
	}

	@media ${theme.responsive.breakpoints.tablet} {
		grid-template-columns: repeat(8, 1fr);
	}

	@media ${theme.responsive.breakpoints.laptop} {
		grid-template-columns: repeat(12, 1fr);
	}

	@media ${theme.responsive.breakpoints.laptopL} {
		padding: 0 ${theme.spacing.xxl};
		column-gap: ${theme.spacing.lg};
	}

	@media ${theme.responsive.breakpoints.desktop} {
		grid-template-columns: repeat(12, 1fr);
	}
`;

export default Grid;
